<div class="page-container">
  <app-page-header title="Healthy Gourmet Kitchens">
    <div class="header-actions" header-actions>
      <p-iconfield iconPosition="left">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          pInputText
          placeholder="Search Healthy Gourmet Kitchens"
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="applyFilters()"
        />
      </p-iconfield>
      <p-select
        class="status-filter"
        placeholder="All statuses"
        optionLabel="label"
        optionValue="value"
        [options]="statusOptions"
        [showClear]="true"
        [(ngModel)]="selectedStatus"
        (onChange)="applyFilters()"
      ></p-select>
      <p-button icon="pi pi-search" label="Apply" severity="primary" size="small" (onClick)="applyFilters()"></p-button>
      <p-button
        icon="pi pi-filter-slash"
        label="Clear"
        severity="secondary"
        [disabled]="!hasActiveFilters()"
        [text]="true"
        (onClick)="clearFilters()"
      ></p-button>
    </div>
  </app-page-header>

  @if (error()) {
    <p-message severity="error" text="Failed to load Healthy Gourmet Kitchens. Please try again."></p-message>
  }

  <p-table
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    dataKey="id"
    [lazy]="true"
    [loading]="loading()"
    [paginator]="true"
    [rows]="pageSize()"
    [showCurrentPageReport]="true"
    [sortField]="sortField()"
    [sortOrder]="sortOrder()"
    [totalRecords]="totalRecords()"
    [value]="producers()"
    (onPage)="onPage($event)"
    (onSort)="onSort($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          Healthy Gourmet Kitchen
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th>Status</th>
        <th>Contact</th>
        <th pSortableColumn="createdOn">
          Created
          <p-sortIcon field="createdOn"></p-sortIcon>
        </th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template let-producer pTemplate="body">
      <tr class="producer-row" (click)="openDetail(producer)">
        <td>
          <span class="producer-link">{{ producer.name }}</span>
        </td>
        <td>
          <p-tag [severity]="statusSeverity(producer)" [value]="producer.status"></p-tag>
        </td>
        <td>{{ producer.email || '—' }}</td>
        <td>{{ producer.createdOn | date: 'mediumDate' }}</td>
        <td>
          <p-button
            icon="pi pi-eye"
            label="View Details"
            severity="info"
            size="small"
            [text]="true"
            (onClick)="openDetail(producer); $event.stopPropagation()"
          ></p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty-message-cell" colspan="5">
          <p-message severity="info" text="No Healthy Gourmet Kitchens match your filters."></p-message>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <tr>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
          <td><p-skeleton></p-skeleton></td>
        </tr>
      }
    </ng-template>
  </p-table>
</div>
